var React = require('react');

function CareerPathButtonChevronBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.212621 1.29674C-0.087507 0.983214 -0.067514 0.494532 0.257489 0.205033C0.582627 -0.0843763 1.08941 -0.0650982 1.38963 0.248299L8.78765 7.97578C9.07078 8.27174 9.07078 8.72827 8.78765 9.02422L1.38963 16.7517C1.08941 17.0651 0.582627 17.0844 0.257489 16.795C-0.0675143 16.5055 -0.0875072 16.0168 0.212621 15.7033L7.1077 8.5L0.212621 1.29674Z","fill":"#4C0FFB"}));
}

CareerPathButtonChevronBlue.defaultProps = {"width":"9","height":"17","viewBox":"0 0 9 17","fill":"none"};

module.exports = CareerPathButtonChevronBlue;

CareerPathButtonChevronBlue.default = CareerPathButtonChevronBlue;
